const PATH = '/builder/secrets';

export const secrets = $axios => ({
  get: (sheetId, params = {}) => $axios.$get(`${PATH}/${sheetId}`, { params }),
  list: params => $axios.$get(PATH, { params }),
  create: data => $axios.$post(PATH, data),
  update: (sheetId, data = {}) => $axios.$patch(`${PATH}/${sheetId}`, data),
  delete: sheetId => $axios.$delete(`${PATH}/${sheetId}`),
});
